<template>
  <div class="order-page">
    <Card class="order-card" v-for="order in datas" :key="order.orderID">
      <p slot="title">
        <Row>
          <Col span="5">{{$t('plan.Order.orderNo')}}:{{order.orderNo}}</Col>
          <Col span="5">{{$t('plan.Order.customer')}}:{{order.customer}}</Col>
          <Col span="5">{{$t('plan.Order.ordersTime')}}:{{order.ordersTime}}</Col>
          <Col span="5">{{$t('plan.Order.salesman')}}:{{order.salesman}}</Col>
        </Row>
      </p>
      <Table size="small" class="order-table" highlight-row stripe border :columns="columns" :data="order.orderProducts"></Table>
    </Card>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Order',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('plan.Order.index'), width: 65 },
        { title: this.$t('plan.Production.productName'), key: 'name' },
        { title: this.$t('plan.Order.productNo'), key: 'productNo' },
        { title: this.$t('plan.Order.num'), key: 'num' },
        { title: this.$t('plan.Order.unit'), key: 'unit' },
        { title: this.$t('plan.Order.attritionRate'), key: 'attritionRate' },
        { title: this.$t('plan.Order.output'), key: 'output' },
        { title: this.$t('plan.Order.deliveryTime'), key: 'deliveryTime' },
        {
          title: this.$t('plan.Order.action'),
          key: 'action',
          width: 125,
          render: (h, params) => {
            // console.log(params, params.row, params.row.valid)
            if (this.permissions === true) {
              if (params.row.valid === 1) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.close(params.row, params.index)
                      }
                    }
                  }, this.$t('plan.Order.case1'))
                ])
              } else {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, this.$t('plan.Order.case2'))
                ])
              }
            } else {
              if (params.row.valid === 1) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: true
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, this.$t('plan.Order.case1'))
                ])
              } else {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: true
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, this.$t('plan.Order.case2'))
                ])
              }
            }
          }
        }
      ],
      datas: [],
      permissions: false
    }
  },
  computed: {
  },
  methods: {
    close (row, index) {
      if (confirm(this.$t('plan.Order.delete_message'))) {
        Api.orderPlan.close(row.id).then(() => {
          for (let i = 0; i < this.datas.length; i++) {
            if (this.datas[i].orderID === row.orderID) {
              this.datas[i].orderProducts[index].valid = 0
            }
          }
        })
      }
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'production_plan' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.orderPlan.list().then(res => {
      next(vm => {
        let d = []
        vm.datas = res.orderInfos
        for (let i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].Ordervalid === 1) {
            for (let j = 0; j < vm.datas[i].orderProducts.length; j++) {
              if (vm.datas[i].orderProducts[j].unit === 1) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Meter')
              } else if (vm.datas[i].orderProducts[j].unit === 2) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Yard')
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output * 1.0936
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output.toFixed(0)
              } else if (vm.datas[i].orderProducts[j].unit === 3) {
                vm.datas[i].orderProducts[j].unit = vm.$t('plan.Order.Gross')
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output / (144.0 * 0.9144)
                vm.datas[i].orderProducts[j].output = vm.datas[i].orderProducts[j].output.toFixed(0)
              }
            }
            d.push(vm.datas[i])
          }
        }
        vm.datas = d
      })
    })
  }
}
</script>
<style>
.order-page {
  padding: 10px;
}
.order-card {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// Order.vue?def5a75e